import React from 'react'
export const Features = () => {

    return (
        <div className="main-container my-5 p-2">
            <h1 className="text-center my-2">Features</h1>
            <div className="container bg-light p-5 my-5">
                <h4>What is File Conversion Utility</h4>
                <p>File Conversion Utility is a web app that compress images with best quality and compression ratio. It will compress images offline without using internet thus it saves the data of the users.  It will be a Business-to-consumer Model. </p>
                <p>File Conversion Utility will also have a converter which is use to convert all type of file format into different file format. We are using React JS Library for frontend and Node JS for backend. </p>

                <ol>
                    <li> Best Quality Compression ratio </li>
                    <li> Online image compression for best user Experience as well as you can compressed offline also</li>
                    <li>Best Converter</li>
                </ol>

                <p>
                    <h4>We are very easy to use</h4>
                    Not so computer-savvy? No problem. Even if it’s your first time using File Conversion Utility, we made it extremely simple. Our interface is user friendly. Our tools know how to do their job. So you shouldn’t encounter any setbacks.
                </p>

                <p>
                    <h4>What matters to you, matters to us</h4>
                    When it comes to dealing with your files, it is our task and duty to provide the best possible service

                    <br />  <b>The importance of a file</b>  <br />
                    We strive to bring you the smallest file size possible while maintaining the quality at its best.
                </p>

                <p>
                    <h4>Enjoy a wiser use of time</h4>
                    We have created an entire suite of optimal tools which will speed up your document processes
                </p>

                <p>
                    <h4>Freedom to choose your platform</h4>
                    Keep up with your work from your favorite device. Our tools are accessible from the web, mobile and desktop
                </p>


            </div>
        </div>

    )
}
